import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const AlertTriangle = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.646 16.8747C18.7656 17.0818 18.6161 17.3408 18.3769 17.3408H5.99927C5.76007 17.3408 5.61057 17.0818 5.73017 16.8747L11.919 6.15535C12.0386 5.94821 12.3375 5.94822 12.4571 6.15535L18.646 16.8747ZM11.0529 5.65535L4.86417 16.3747C4.35967 17.2485 4.99027 18.3408 5.99927 18.3408H18.3769C19.3859 18.3408 20.0165 17.2485 19.512 16.3747L13.3232 5.65535C12.8187 4.78155 11.5574 4.78155 11.0529 5.65535ZM11.646 8.84082V13.8408H12.646V8.84082H11.646ZM11.646 16.3408V15.3408H12.646V16.3408H11.646Z"
      fill="currentColor"
    />
  </svg>,
  'AlertTriangle'
);
